import { ModalBodyWrapper } from './AccountModal'
import { FieldSelect } from './FieldSelect'
import { useFormInput } from '../hooks/useFormInput'
import { AccountBannerFormAppointments } from './AccountBannerTransaction'
import { useAccountLayoutContext } from './AccountProfileContext'
import { shoeWidthOptions, shoeSizeOptions } from '../helpers/GlobalAssets'
import { accountTranslations } from '../helpers/translations'
import { useState } from 'preact/hooks'
const baseMeasurementKey = 'AU/UK'

/**
 *
 * @param {{[key: string]: string}[]} data
 */
const parseShoeData = (data, baseKey, includedKeyInLabel = true) => {
  return data.map((d) => {
    const value = d[baseKey]
    const label = includedKeyInLabel ? `${baseKey} ${value}` : value
    return {
      label,
      value
    }
  })
}
/**
 *
 * @param {{handleToggle: () => void, handleUpdateView: () => void}} props
 * @returns
 */
export const FormAddMeasurements = (props) => {
  const { omneoClient } = useAccountLayoutContext()
  const { formInputs, handleOnChange } = useFormInput({
    shoeSize: '',
    shoeWidth: ''
  })
  const [isLoading, setIsLoading] = useState(false)

  const parsedShoeSizeOptions = [{ label: 'Select Size', value: -1 }].concat(
    parseShoeData(shoeSizeOptions, baseMeasurementKey)
  )
  const parsedShoeWidthOptions = [{ label: 'Select Width', value: -1 }].concat(
    parseShoeData(shoeWidthOptions, baseMeasurementKey, false)
  )

  return (
    <ModalBodyWrapper
      config={{
        isLoading,
        title: 'New Measurement',
        handleToggle: props.handleToggle,
        submitButtonText: 'Save',
        submitCallback: async (e) => {
          e.preventDefault()
          setIsLoading(true)
          if (
            !formInputs.shoeSize.value ||
            formInputs.shoeSize.value === -1 ||
            !formInputs.shoeWidth.value ||
            formInputs.shoeWidth.value === -1
          ) {
            alert('Please select both shoe size and width.')
            setIsLoading(false)
            return
          }

          /** Using omneo SDK to fetch child profile connection details */
          const connection = omneoClient.client.profile.Connection(props.connectionId)
          const { id } = await connection.get()

          // format: '2024-11-21 04:01:40',
          const date = new Date()
          const dateString = date.toISOString()
          const formattedDate = dateString.split('T')[0] + ' ' + dateString.split('T')[1].split('.')[0]

          const body = {
            action: 'service',
            profile_id: id,
            channel: 'app',
            signal: 1,
            name: 'Measurement Recorded',
            namespace: 'omneo',
            interacted_at: formattedDate,
            meta: {
              measurement: {
                size_shoe: {
                  unit: 'AU/UK',
                  value: formInputs.shoeSize.value
                },
                width_shoe: {
                  unit: 'AU/UK',
                  value: formInputs.shoeWidth.value
                }
              }
            }
          }

          const create = await omneoClient.profileClient.createChildProfileMeasurements(props.connectionId, body)
          setIsLoading(false)
          props.handleToggle()
          props.handleUpdateView()
        }
      }}
    >
      <FieldSelect
        label={accountTranslations.form_labels.size}
        onChange={handleOnChange}
        name={formInputs.shoeSize.key}
        value={formInputs.shoeSize.value}
        options={parsedShoeSizeOptions}
      />
      <FieldSelect
        label={accountTranslations.form_labels.width}
        onChange={handleOnChange}
        name={formInputs.shoeWidth.key}
        value={formInputs.shoeWidth.value}
        options={parsedShoeWidthOptions}
      />
      <AccountBannerFormAppointments />
    </ModalBodyWrapper>
  )
}
